/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGATourModelGetOrCreateCalcFeatureInput = {|
  modelId?: ?string,
  calcName?: ?string,
  calcId?: ?string,
  clientMutationId?: ?string,
|};
export type PGAModelBuilderPageAddCalcMutationVariables = {|
  input: PGATourModelGetOrCreateCalcFeatureInput
|};
export type PGAModelBuilderPageAddCalcMutationResponse = {|
  +pgaTourModelCreateCalcFeature: ?{|
    +success: ?boolean
  |}
|};
export type PGAModelBuilderPageAddCalcMutation = {|
  variables: PGAModelBuilderPageAddCalcMutationVariables,
  response: PGAModelBuilderPageAddCalcMutationResponse,
|};
*/


/*
mutation PGAModelBuilderPageAddCalcMutation(
  $input: PGATourModelGetOrCreateCalcFeatureInput!
) {
  pgaTourModelCreateCalcFeature(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGATourModelGetOrCreateCalcFeaturePayload",
    "kind": "LinkedField",
    "name": "pgaTourModelCreateCalcFeature",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderPageAddCalcMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderPageAddCalcMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "99f9ecb3547040a348ea0000ac002395",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderPageAddCalcMutation",
    "operationKind": "mutation",
    "text": "mutation PGAModelBuilderPageAddCalcMutation(\n  $input: PGATourModelGetOrCreateCalcFeatureInput!\n) {\n  pgaTourModelCreateCalcFeature(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e248d6ff1b183ece501d7556ff0e5fa2';

module.exports = node;
